<mat-nav-list class="margin-bottom-md">
  @for (action of actions; track action) {
    @if (!action.disabled) {
      <a mat-list-item (click)="action.action(); onOpenLink($event);">
        <span mat-line>{{action.name}}</span>
      </a>
    }
    @if (action.disabled) {
      <mat-list-item [disableRipple]='true'>
        {{action.name}}
      </mat-list-item>
    }
  }
</mat-nav-list>
